type CreditReport {
  accounts: [Account!]
  accounts_aggregation: [AggregatedAccount!]
  personal_information: PersonalInformation
  public_information: PublicInformation
  retrieval_timestamp: String
  score: Int
  max_score: Int
  searches: [Search!]
  warnings: [Warnings]
  changes: [Change]
}

enum Warning {
  INVALID_WARNING
  CREDIT_UTILISATION_INCREASED
  NEW_CREDIT_TAKEN_OUT
  NEW_MISSED_PAYMENTS_OR_ARREARS
  NEW_LEGAL_ACTION
}

type Warnings {
  warning: Warning
  identifiers: [String]
}

enum Changes {
  INVALID_CHANGE
  CREDIT_UTILISATION_DECREASED
  CREDIT_REMOVED
  NEW_CREDIT_SEARCH
  ELECTORAL_ROLL_REGISTERED
}

enum SearchType {
  INVALID_SEARCH_TYPE
  HARD
  SOFT
}

type Change {
  change: Changes
  identifiers: [String]
}

type AggregatedAccount {
  key: String
  account_creditor: String
  account_type: String
  monthly_repayment: Int
  status: String
}

type PublicInformation {
  bankruptcies: [Bankruptcy!]
  ccjs: [CCJ!]
  corrections: [Correction!]
  electoral_rolls: [ElectoralRoll!]
  ivas: [IVA!]
}

type Account {
  account_number: String
  balance: Int
  credit_limit: Int
  creditor: String
  end_date: String
  monthly_repayment: Int
  payment_status: PaymentStatusSummary
  remaining_term: Int
  start_date: String
  status: AccountStatus
  type: DebtType
  payment_history: [PaymentHistoryCredit!]
}

type PaymentHistoryCredit {
  age_in_months: Int!
  date: String!
  status: PaymentStatus!
}

type PersonalInformation {
  address: PersonalAddress
  dob: String
  name: Name
}

type PersonalAddress {
  address_1: String
  address_2: String
  address_3: String
  country: String
  county: String
  postcode: String
  posttown: String
  is_current_correspondence: Boolean
}

type Name {
  forename: String
  surname: String
}

type Bankruptcy {
  bankruptcy: String
  court: String
  discharge: String
}

type CCJ {
  amount: Int
  court_name: String
  date_registered: String
  date_satisfied: String
}

type Correction {
  date: String
  name: Name
  text: String
}

type ElectoralRoll {
  address: PersonalAddress
  from_year: String
  name: Name
  to_year: String
}

type IVA {
  completed: String
  registered: String
}

type Search {
  company_name: String!
  search_date: String!
  type: SearchType
}

type CreditReportResponse {
  reports: [CreditReport!]
}
